import React from 'react';
import { SubTitle } from '../../../common/sharedComponents/SubTitle';
import { SubTitleDepartment, SubTitleSection } from './styled.myAuditSubTitle';
import { Headline4 } from './../../../common/typography';

export interface IMyAuditSubTitle {
  department: string;
  sections: string[];
}

export function MyAuditSubTitle ({ department, sections }: IMyAuditSubTitle) {
  const sectionsString = sections.map((section) => section).join(', ');
  return (
    <SubTitle>
      <SubTitleDepartment>
        <Headline4>
          {`${department}:`}
          <SubTitleSection color="dimGray">{sectionsString}</SubTitleSection>
        </Headline4>
      </SubTitleDepartment>
    </SubTitle>
  );
}
